import router from '../../router'
import { auth, googleProvider } from '@/firebase'

export default {
  state: {
    userData: null
  },
  mutations: {
    SET_USER_DATA (state, payload) {
      state.userData = payload
    }
  },
  actions: {
    logInGoogle ({ commit, dispatch }) {
      return auth.signInWithPopup(googleProvider)
        .then((res) => {
          const data = {
            uid: res.user.uid,
            email: res.user.email,
            displayName: res.user.displayName
          }
          commit('SET_USER_DATA', data)
          router.push({ name: 'Home' })
        })
        .catch((error) => {
          dispatch('setAlertData', {
            msg: error.message,
            visible: true,
            type: 'danger'
          })
          console.warn(error)
        })
    },
    userSignOut ({ commit }) {
      auth.signOut()
      commit('SET_USER_DATA', null)
      router.push({ name: 'LogIn' })
    },
    /**
     * AutoLogIn
     * @param commit
     * @param payload {Object} Keys: uid, email, displayName
     */
    autoLogIn ({ commit }, payload) {
      commit('SET_USER_DATA', payload)
      // Not working
      // router.push({ name: 'Home' })
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.userData !== null && state.userData !== undefined
    },
    userId (state) {
      return state.userData !== null && state.userData !== undefined ? state.userData.uid : null
    }
  }
}
